module.exports = __webpack_public_path__ + "img/sign-in-success.1d457f19.png";